/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryItemEditViewToController(
    this: JS5Object,
    _: JS5Object,
    EnumService: JS5Object,
    $routeParams: JS5Object,
) {

    this.deliveryItemExists = () => {
        return $routeParams.deliveryItemId !== '-1';
    };

    this.isTemplateRequired = () => {
        return this.templateType !== 'Passthrough';
    };

    this.onTemplateTypeChanged = (type: string) => {
        this.templateType = type;
        setVisibleFormControls($routeParams.deliveryItemType);
        _.invoke(this, 'onMediaConversionTemplateTypeChange', {type: this.templateType});
    };

    const setVisibleFormControls = (type: string) => {
        switch (type) {
            case 'Video':
                this.visibleFormControls = {
                    templateDropdown: true,
                    forceVantageComposition: this.templateType === 'Vantage',
                    vantageProcessorName: this.templateType === 'Vantage',
                    vantageVideoNickname: this.templateType === 'Vantage',
                    fadeInDuration: this.templateType === 'Vantage',
                    fadeOutDuration: this.templateType === 'Vantage',
                    startTimecode: this.templateType === 'Vantage',
                    disableNielsenWatermarking: this.templateType === 'Vantage',
                    disableNexGuardWatermarking: this.templateType === 'Vantage',
                    conversionTemplateVariables: this.templateType === 'Hybrik',
                    splitAndStitch: true,
                    minDuration: true,
                    maxNumberOfSplits: true,
                    activePixelsWidth: true,
                    activePixelsHeight: true
                };
                break;
            case 'Audio':
                this.visibleFormControls = {
                    templateDropdown: true
                };
                break;
            case 'Artwork':
            case 'Image':
                this.visibleFormControls = {
                    imageTemplate: true
                };
                break;
            case 'CC':
            case 'Subtitle':
                this.visibleFormControls = {
                    closedCaptionsSubtitleProfile: true,
                    macCaptionTemplate: true
                };
                break;
            case 'Metadata':
                this.visibleFormControls = {
                    metaDataProfile: true,
                    createAFileForEachAct: true
                };
                break;
            default :
                this.visibleFormControls = null;
                console.warn(`Unknown delivery item type [${this.editData.type}] when setting visibly form controls `);
                break;
        }
    };

    const setTemplateTypeDropdown = () => {
        this.nullTemplateType = this.deliveryItemExists() ? 'Passthrough' : null;
    };

    const setFormControls = () => {
        setTemplateTypeDropdown();
    };

    this.$onInit = () => {
        this.availableClosedCaptionAssetContentTemplates = _.filter(this.assetContentTemplates, {contentType: 'CC'});
        this.availableImageAssetContentTemplates = _.filter(this.assetContentTemplates, {contentType: 'IMAGE'});
        this.availableMediaConversionTemplates = this.mediaConversionTemplates;
        this.availableMacCaptionTemplates = this.macCaptionTemplates;
        if ($routeParams.deliveryItemType === 'Video') {
            this.tooltipTemplate = 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/to/to-panel-template-type-tooltip-template.html';
        }

        setFormControls();
        setVisibleFormControls($routeParams.deliveryItemType);
    };

    this.$onChanges = () => {
        setFormControls();
        setVisibleFormControls($routeParams.deliveryItemType);
    };
}

angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewTo', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/to/delivery-items-edit-view-to-template.html',
    controller: DeliveryItemEditViewToController,
    bindings: {
        editData: '<',
        mediaConversionTemplates: '<',
        assetContentTemplates: '<',
        transformTemplates: '<',
        macCaptionTemplates: '<',
        conversionTemplateVariableComponentsMap: '<',
        onMediaConversionTemplateTypeChange: '&?'
    }
});



